/**
 * Shared constants for video upload functionality
 */

export const VideoUploadTipsConstants = [
  'Videos must be less than two minutes.',
  'Video file format must be MP4, AVI or MOV.',
  'Videos must be about the listing.',
  'Videos cannot include any company/agent branding, music, text or voiceover.',
  'Videos cannot include people.',

] as const;

export const VideoLinkTipsConstants = [
  'Videos must be less than two minutes.',
  'Video links must be a YouTube or Vimeo URL.',
  'Videos must be about the listing.',
  'Videos cannot include any company/agent branding, music, text or voiceover.',
  'Videos cannot include people.',

] as const;

export const VideoLinkPropertyWebsiteTipsConstants = [
  'Video links must be a YouTube or Vimeo URL.',
] as const;

export const VideoUploadTitle = 'Upload a video file of your listing. This video will be used for your YouTube ad.';
